module.exports = require("@formatjs/intl-relativetimeformat/locale-data/fr");